import { ArrowRight, Building2, Eye, EyeOff, Lock, Mail, User } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { registrar } from '../api';

export default function Register({ onAuth, onIrALogin }) {
  const [form, setForm] = useState({ email: '', password: '', nombre: '', apellido: '', nombre_empresa: '', ruc: '' });
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [cargando, setCargando] = useState(false);

  function set(campo) {
    return (e) => setForm((f) => ({ ...f, [campo]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setCargando(true);
    try {
      const data = await registrar(form);
      onAuth(data.empresa);
      toast.success('Cuenta creada. ¡Bienvenido!');
    } catch (err) {
      const detalle = err.response?.data;
      const mensaje = detalle ? Object.values(detalle).flat().join(' ') : 'No se pudo registrar la cuenta.';
      toast.error(mensaje);
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="auth-card">
      <div className="auth-icono"><Building2 size={22} /></div>
      <h2>Registra tu empresa</h2>
      <p className="auth-subtitulo">Hub Financiero — Generador de Cheques</p>

      <form onSubmit={handleSubmit}>
        <div className="coord-inputs">
          <div>
            <label>Nombre</label>
            <div className="input-con-icono">
              <User size={16} />
              <input value={form.nombre} onChange={set('nombre')} placeholder="Tu nombre" required />
            </div>
          </div>
          <div>
            <label>Apellido</label>
            <input value={form.apellido} onChange={set('apellido')} placeholder="Tu apellido" required />
          </div>
        </div>

        <label>Nombre de la empresa</label>
        <div className="input-con-icono">
          <Building2 size={16} />
          <input value={form.nombre_empresa} onChange={set('nombre_empresa')} placeholder="Ej. Comercial Andina S.A." required />
        </div>

        <label>RUC (opcional)</label>
        <input value={form.ruc} onChange={set('ruc')} maxLength={13} />

        <label>Correo electrónico</label>
        <div className="input-con-icono">
          <Mail size={16} />
          <input type="email" value={form.email} onChange={set('email')} placeholder="tucorreo@empresa.com" required />
        </div>

        <label>Contraseña</label>
        <div className="input-con-icono">
          <Lock size={16} />
          <input
            type={mostrarPassword ? 'text' : 'password'}
            value={form.password}
            onChange={set('password')}
            placeholder="Mínimo 8 caracteres"
            required
            minLength={8}
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setMostrarPassword((v) => !v)}
            aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          >
            {mostrarPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>

        <button className="btn-primary" type="submit" disabled={cargando}>
          <ArrowRight size={16} /> {cargando ? 'Creando cuenta…' : 'Crear cuenta gratis'}
        </button>
      </form>
      <p className="auth-switch">
        ¿Ya tienes cuenta? <button type="button" onClick={onIrALogin}>Inicia sesión</button>
      </p>
    </div>
  );
}
